// extracted by mini-css-extract-plugin
export default {"page":"PageLayout_page__CsVyQ","inner":"PageLayout_inner__cTa3Y"};